module.exports = __webpack_public_path__ + "static/media/media1.7e633063.png";